import { render, staticRenderFns } from "./TimeSlice.vue?vue&type=template&id=4cbbb0d4&scoped=true"
import script from "./TimeSlice.vue?vue&type=script&lang=js"
export * from "./TimeSlice.vue?vue&type=script&lang=js"
import style0 from "./TimeSlice.vue?vue&type=style&index=0&id=4cbbb0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbbb0d4",
  null
  
)

export default component.exports